import { MaybeString } from '.'
import { SelectOption } from '../components'

export const getSelectOptionDisplayValue = (
  options: SelectOption[] | undefined,
  newValue: MaybeString
) =>
  (options &&
    options.find((option: SelectOption) => {
      return option.value === newValue
    })?.display) ||
  ''
